import Numeral from 'numeral';

Numeral.options.scalePercentBy100 = false;

export const convertToFloat = (number) => {
    if (!number) return 0.00;
    return Numeral(number).value();
};

export const convertToPercent = number => Numeral(number).format('0.00 %');
export const convertToCurrency = number => Numeral(number).format('$ 0,0.00');
export const convertToCurrencyNoSymbol = number => Numeral(number).format('0,0.00');
export const convertToInt = number => Numeral(number).format('0');
export const convertToConciceCurrency = number => Numeral(number).format('$0.[0]a');
export const convertToConcicePercent = number => Numeral(number).format('0.[00]%');

export const formatInputValue = (number, format, concise) => {
    switch (format) {
    case 'currency':
        if (concise) return convertToConciceCurrency(number);
        return convertToCurrency(number);
    case 'percent':
        if (concise) return convertToConcicePercent(number);
        return convertToPercent(number);
    case 'int':
        return convertToInt(number);
    default:
        return number;
    }
};

export const capitalize = text => text[0].toUpperCase() + text.slice(1);

const TRUNCATE_LENGTH = 350;

export const truncate = text => `${text.slice(0, TRUNCATE_LENGTH).split(' ').slice(0, -1).join(' ')}...`;

export const truncateSentence = text => `${text.split('.')[0]}.`;

const HEADING_THRESHOLD_CHARS = 15;

export const splitArticle = (text) => {
    const paragraphs = text.split('</p>');
    let index = 0;
    for (let count = 0; index < paragraphs.length; index++) {
        if (paragraphs[index].split(' ').length > HEADING_THRESHOLD_CHARS) count++;
        if (count > 2) break;
    }

    return [paragraphs.slice(0, index + 1).join('</p>'), paragraphs.slice(index + 1).join('</p>')];
};

export const buildTagLink = (tag, forAwards) => {
    if (tag === 'awards') return '/wyse-awards';
    return `/${forAwards ? 'wyse-awards' : 'articles'}/${tag.toLowerCase()}`;
};

const AUTHORS = {
    stephen: 'Stephen N.',
    cristian: 'Cristian D.',
    aaron: 'Aaron A.',
};

export const normalizeAuthor = (text) => {
    let authorNormalized;
    const lowercaseText = text.toLowerCase();
    Object.keys(AUTHORS).forEach((author) => {
        if (lowercaseText.indexOf(author) > -1) {
            authorNormalized = author;
        }
    });
    return authorNormalized;
};

export const formatAuthor = text => AUTHORS[normalizeAuthor(text)];
